import { useLang } from "../context/LanguageContext";
import { FadeUp, InviewMaskLine, RevealImage } from "../components/Reveal";

const IMG = "/images/about.webp";

export default function About() {
  const { t } = useLang();
  return (
    <div className="bg-[#050607]" data-testid="about-page">
      <section className="px-5 md:px-10 pt-40 pb-20 md:pt-48 md:pb-28 border-b border-white/10">
        <FadeUp><div className="eyebrow mb-8">{t("about.eyebrow")}</div></FadeUp>
        <h1 className="font-display text-[36px] sm:text-[54px] lg:text-[68px] text-[#F3F3F0] max-w-5xl">
          {t("about.title").split("\n").map((l, i) => <InviewMaskLine key={i} delay={0.2 + i * 0.14} className={i === 1 ? "text-[#999995]" : ""}>{l}</InviewMaskLine>)}
        </h1>
        <FadeUp delay={0.35}><p className="mt-10 max-w-xl text-[15px] md:text-[17px] leading-relaxed text-[#999995]">{t("about.p1")}</p></FadeUp>
        <FadeUp delay={0.45}><p className="mt-5 max-w-xl text-[15px] md:text-[16px] leading-relaxed text-[#8A8A86]">{t("about.p2")}</p></FadeUp>
      </section>

      <section className="px-5 md:px-10 py-20 md:py-28 grid grid-cols-1 lg:grid-cols-[2fr_1fr] gap-14 border-b border-white/10">
        <div className="order-2 lg:order-1">
          <FadeUp><div className="eyebrow mb-6">{t("about.focusTitle")}</div></FadeUp>
          <div className="border-t border-white/10">
            {t("about.focus").map((f, i) => (
              <FadeUp key={f} delay={i * 0.04}>
                <div className="flex items-baseline justify-between border-b border-white/10 py-5 group">
                  <span className="font-display text-[22px] md:text-[30px] text-[#F3F3F0] group-hover:pl-3 transition-all duration-500">{f}</span>
                  <span className="mono text-[11px] text-[#555654]">{String(i + 1).padStart(2, "0")}</span>
                </div>
              </FadeUp>
            ))}
          </div>
        </div>
        <div className="self-start order-1 lg:order-2">
          <RevealImage src={IMG} alt="Dubai skyline — between two markets" className="aspect-[3/4] w-full max-w-[440px]" />
        </div>
      </section>

      <section className="px-5 md:px-10 py-20 md:py-28">
        <FadeUp><div className="eyebrow mb-10">{t("about.valuesTitle")}</div></FadeUp>
        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-5 border-t border-l border-white/10">
          {t("about.values").map((v, i) => (
            <FadeUp key={v.t} delay={i * 0.05} className="border-b border-r border-white/10 p-6 md:p-7" data-testid={`about-value-${v.t.toLowerCase()}`}>
              <h3 className="mono text-[11px] tracking-[0.22em] text-[#F3F3F0] mb-3">{v.t}</h3>
              <p className="text-[12px] leading-relaxed text-[#8A8A86]">{v.d}</p>
            </FadeUp>
          ))}
        </div>
      </section>
    </div>
  );
}
